<div class="copyright">
    <p>
        <a href="http://www.prosoccerdata.com" target="_blank" class="signup">www.prosoccerdata.com</a>
    </p>
    <p>
        <a class="signup" href="http://www.prosoccerdata.com/nl/legal/termsofuse" target="_blank">{{'central-login.terms.of.use' | translate }}</a> -
        <a class="signup" href="http://www.prosoccerdata.com/nl/legal/privacy" target="_blank">{{'central-login.privacy' | translate }}</a> -
        <a class="signup" href="http://www.prosoccerdata.com/nl/legal/cookies" target="_blank">{{'central-login.cookies' | translate }}</a>
    </p>
    <p></p>
    <ul class="social-icons" style="width:68px; margin:0 auto;">
        <li><a href="https://www.facebook.com/ProSoccerData" data-original-title="facebook" target="_blank" class="facebook"></a></li>
        <li><a href="https://twitter.com/ProSoccerData" data-original-title="twitter" target="_blank" class="twitter"></a></li>
    </ul>
    <p></p>
</div>
